/**
 * Hairline divider between MenuItem groups.
 */
export interface MenuSeparatorProps {
  className?: string;
}

export function MenuSeparator({ className }: MenuSeparatorProps): JSX.Element {
  return <div role="separator" className={["gk-menu__sep", className].filter(Boolean).join(" ")} />;
}
